import { LoginSlider } from './Slider';
import { FC } from 'react';
import styled from 'styled-components';
import logo from './mainLogo.svg';

const Root = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #fafafa;
  display: flex;
  align-items: stretch;
`;

const Logo = styled.img`
  height: 32px;
  align-self: flex-start;
`;

const Content = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  min-width: 0;
  min-height: 0;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
`;

const Form = styled.div`
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
`;

export const LoginLayout: FC = ({ children }) => {
  return (
    <Root>
      <Form>
        <Header>
          <Logo src={logo}></Logo>
        </Header>
        <Content>{children}</Content>
      </Form>
      <LoginSlider />
    </Root>
  );
};
